/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Plan_TitleInputs */

const en_platform_view_plan_title = /** @type {(inputs: Platform_View_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A plan that gets done`)
};

const pl_platform_view_plan_title = /** @type {(inputs: Platform_View_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan, który się robi`)
};

/**
* | output |
* | --- |
* | "A plan that gets done" |
*
* @param {Platform_View_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_plan_title = /** @type {((inputs?: Platform_View_Plan_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Plan_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_plan_title(inputs)
	return en_platform_view_plan_title(inputs)
});